<script>
export default {
  name: 'mixin-wait',
  data() {
    return {
      isWaiting: false,
    }
  },
  methods: {
    waitFor(promise) {
      if (this.isWaiting) {
        return false
      }

      this.isWaiting = true
      promise.then(() => {
        this.isWaiting = false
        return arguments
      }).catch(() => {
        this.isWaiting = false
        return Promise.reject.apply(Promise, arguments)
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// wait.vue?1185421a